var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "d-flex flex-column",
    attrs: {
      "flat": "",
      "color": "grey-f7",
      "height": "640",
      "width": "320"
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-list', {
    staticStyle: {
      "flex-grow": "0"
    },
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-16"
  }, [_c('v-list-item-avatar', {
    attrs: {
      "color": "white",
      "rounded": ""
    }
  }, [_c('v-img', {
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-icon', [_vm._v("mdi-domain")])];
      },
      proxy: true
    }])
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" 마이스펙 챗봇 ")]), _c('v-list-item-subtitle', [_c('v-btn', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" 사용안내 ")])], 1)], 1)], 1)], 1), _c('v-card-text', {
    staticClass: "pt-0 px-16",
    staticStyle: {
      "flex-grow": "1",
      "flex-shrink": "1",
      "overflow": "hidden"
    }
  }, [_c('view-messages')], 1), _c('v-card-actions', [_c('v-text-field', _vm._b({
    attrs: {
      "flat": "",
      "solo": "",
      "rounded": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-btn', _vm._b({
          staticClass: "mr-n8",
          attrs: {
            "x-small": "",
            "rounded": "",
            "fab": "",
            "color": "primary"
          },
          on: {
            "click": _vm.send
          }
        }, 'v-btn', _vm.inputAttrs, false), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-send")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }, 'v-text-field', _vm.inputAttrs, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }